import { todayPT } from "@homebound/activesupport";
import { column, GridColumn, GridTableLayout, simpleDataRows, SimpleHeaderAndData } from "@homebound/beam";
import { dateCell, emptyCellDash } from "src/components";
import { pluralize } from "src/utils";
import { Temporal } from "temporal-polyfill";

// TODO: no schedule-impact API exists yet. `ChangeEvent` only carries the manually entered
// `internalImpactInDays`/`homeownerImpactInDays`, and `draftPlanSchedule` takes explicit task edits rather than a
// change event, so there is nothing to ask the backend for per milestone. Everything below is mocked off today's
// date so the step can show the shape of the answer; replace it wholesale once the API lands.
export type ScheduleImpactMilestone = {
  id: string;
  name: string;
  currentFinish: Temporal.PlainDate;
  changeInDays: number;
};

/** Exported so the Schedule Impact card and this table can never disagree while both are mocked. */
export function mockScheduleImpactMilestones(): ScheduleImpactMilestone[] {
  const today = todayPT();
  return [
    { id: "mock:1", name: "Permitting", currentFinish: today.add({ days: 30 }), changeInDays: 0 },
    { id: "mock:2", name: "Foundation", currentFinish: today.add({ days: 75 }), changeInDays: 5 },
    { id: "mock:3", name: "Framing", currentFinish: today.add({ days: 120 }), changeInDays: 5 },
    { id: "mock:4", name: "Finishes", currentFinish: today.add({ days: 210 }), changeInDays: 12 },
    { id: "mock:5", name: "Final Walkthrough", currentFinish: today.add({ days: 240 }), changeInDays: 12 },
  ];
}

/** The milestone-by-milestone schedule impact of the configuration. Mocked — see the TODO above. */
export function ScheduleImpactTable() {
  return (
    <GridTableLayout
      tableProps={{
        id: "scheduleImpactTable",
        rows: simpleDataRows(mockScheduleImpactMilestones()),
        columns: createColumns(),
      }}
      hideEditColumns
    />
  );
}

type Row = SimpleHeaderAndData<ScheduleImpactMilestone>;

function createColumns(): GridColumn<Row>[] {
  return [
    column<Row>({ header: "Milestone", data: ({ name }) => name, w: 2 }),
    column<Row>({ header: "Current Finish", data: ({ currentFinish }) => dateCell(currentFinish) }),
    column<Row>({
      header: "Proposed Finish",
      data: ({ currentFinish, changeInDays }) => dateCell(currentFinish.add({ days: changeInDays })),
    }),
    column<Row>({
      header: "Change",
      data: ({ changeInDays }) =>
        changeInDays === 0 ? emptyCellDash : `+${changeInDays} ${pluralize(changeInDays, "day")}`,
    }),
  ];
}
